import React, { useEffect, useState } from 'react';
import { ReactComponent as USMapSVG } from './us.svg';

const StyledUSMap = ({ stateStatus, getStateColor, onClick }) => {
  const [electoralData, setElectoralData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/electoral.json`)
      .then(response => response.json())
      .then(data => setElectoralData(data.states));
  }, []);

  return (
    <div className="relative w-full" style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <style>
        {electoralData.map((state) => `
          #${state.abbreviation} {
            fill: ${getStateColor(state.name)};
          }
        `).join('\n')}
      </style>
      <USMapSVG
        onClick={(event) => {
          const stateId = event.target.id;
          const state = electoralData.find(s => s.abbreviation === stateId);
          if (state) {
            onClick(state.name);
          }
        }}
        className="w-full h-auto"
      />
      <svg className="absolute top-0 left-0 w-full h-full pointer-events-none">
        
      </svg>
    </div>
  );
};

export default StyledUSMap;
